/**
 * oldIndex を newIndex に挿入しなおし、並び替えます。
 * (Drag&Drop時の並び替え方法)
 */
export function reorderArrayIndex<T>(
  array: T[],
  oldIndex: number,
  newIndex: number
): T[] {
  const movedItem = array[oldIndex];

  if (!movedItem) {
    throw "対象のアイテムがありません";
  }

  const nextArray = array.filter((_, index) => index !== oldIndex);

  nextArray.splice(newIndex, 0, movedItem);

  return nextArray;
}

/**
 * プリミティブな2つの配列を重複を削除し結合する
 */
export function mergeArraysWithoutDuplicates<T>(array: T[], array2: T[]): T[] {
  const differenceArray = array2.filter(item => !array.includes(item));
  const newArray = [...array, ...differenceArray];

  return newArray;
}
